import Cookies from 'js-cookie';

export default class Redirects {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('wpcf7mailsent', this.handleFormSubmission.bind(this), false);
    }

    handleFormSubmission(event) {
        const formOrigin = this.getFormOrigin(event);
        const postIdField = event.target.querySelector('input[name="meditation-id"]');
        const postId = postIdField ? postIdField.value : null;

        if (formOrigin === 'contact-page') {
            const redirectUrl = redirectUrls.pageContactUrl;
            if (redirectUrl) window.location.href = redirectUrl;
          } else if (formOrigin === 'article-page') {
            Cookies.set('formSubmitted', 'true', { expires: 7 });
            let redirectUrl = redirectUrls.meditationsUrl;
            if (postId) {
                const urlParams = new URLSearchParams({
                    fromPost: postId,
                    showLink: 'true'
                });
                redirectUrl = `${redirectUrl}?${urlParams.toString()}`;
            }
            if (redirectUrl) window.location.href = redirectUrl;
        }
    }

    getFormOrigin(event) {
        if (document.querySelector('.contact-page')) {
            return 'contact-page';
        } else if (document.querySelector('.article-page')) {
            return 'article-page';
        }
        return null;
    }
}
